export type FiltersTypes = {
  network: string;
  zone: string;
  country: string;
  markets: Option[];
  surveDate: string;
  wineType: string;
  wineSubType: string;
  wineGrapeVariety: Option[];
  wineAppelation: Option[];
  wineColor: string;
  wineCountry: string;
  wineRegion: string;
  wineFormatGroup: string;
  spiritFormatGroup: string;
  rangePrices: number[];
  tableTypeActive: string;
  search: string;
  storePriceBand: Option[];
  storeFacingBand: Option[];
  storeAwards: Option[];
  storeWsAward: Option[];
  storeMichelinStar: Option[];
  vintage: Option[];
  storePrimaryType: Option[];
  storeRating: Option[];
  clientRefs: Option[];
  clientCustomRefs: Option[];
  posStatus: string;
};

export interface Option {
  value: string | number;
  label: string;
  icon?: string;
}

export type WineColorType =
  | 'red'
  | 'sparkling'
  | 'sweet'
  | 'white'
  | 'pink'
  | 'fortified';

export const wineColorsRGB = {
  red: 'rgb(144, 3, 3)',
  sparkling: 'yellow',
  sweet: 'orange',
  white: 'silver',
  pink: 'rgb(238,114,114)',
  fortified: 'rgb(139, 90, 43)'
};
